import { useMemo } from 'react';
import { User, Users } from 'lucide-react';
import { useUsers } from '../hooks/useUsers';

export default function OwnerFilter({ value, onChange }) {
  const { supervisors } = useUsers();

  // Build options dynamically: Mine + supervisors + All
  const options = useMemo(() => {
    const opts = [
      { id: 'mine', label: 'Mine', icon: User },
    ];

    // Add supervisors
    supervisors.forEach((supervisor) => {
      opts.push({
        id: supervisor.uid,
        label: supervisor.firstName || supervisor.displayName?.split(' ')[0] || 'User',
        icon: User,
      });
    });

    opts.push({ id: 'all', label: 'All', icon: Users });

    return opts;
  }, [supervisors]);

  return (
    <div className="inline-flex items-center gap-0.5 bg-surface-card/60 rounded-lg border border-border p-0.5">
      {options.map((option) => (
        <button
          key={option.id}
          onClick={() => onChange(option.id)}
          className={`px-2.5 py-1 rounded-md text-xs font-medium cursor-pointer flex items-center gap-1.5 border-none transition-all duration-200 ${
            value === option.id
              ? 'bg-gradient-to-r from-accent to-orange-hover text-surface-base shadow-sm'
              : 'bg-transparent text-text-tertiary hover:text-text-secondary hover:bg-surface-hover'
          }`}
        >
          <option.icon size={12} />
          {option.label}
        </button>
      ))}
    </div>
  );
}
